import React, { useEffect, useState } from 'react'
import { Breadcrumb, Cards, Infoasking, Loader, NoticeCard, QuestionErrorMessage, QuestionForm } from '../../components'
import ErrorMessage from '../../components/errorMessage'
import { useDispatch, useSelector } from 'react-redux';
import { fetchQuestionData, resetQuestionData } from './store/actions';
import { fetchHomepageData, resetHomepageData } from '../homepage/store/actions';
import { getData } from '../../utils/storage';
import { Helmet } from 'react-helmet';
import FontResizeWidget from '../../components/FontResizeWidget';
import { ACCESSIBILITY_FEATURE_ENABLED } from '../../config';
import { useLocation } from 'react-router-dom';
import QuestionryErrorMessage from '../../components/QuestionErrorMessage';

const QuestionsSet = (props) => {

  const location = useLocation();
  const [noticeDescription, setNoticeDescription] = useState("");
  const [questionInfoText, setQuestionInfoText] = useState("");
  const [questionsData, setQuestionsData] = useState("");
  const [actionPlan, setActionPlan] = useState(false);
  const [postCode, setPostCode] = useState(false);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(null);
  const [topicsData, setTopicData] = useState([]);
  const questionDataFetch = useSelector((state) => state.questionSet);
  const topicList = useSelector((state) => state.home);
  //.  console.log("data inside props:-",location.state);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchQuestionData());
  }, [])

  useEffect(() => {
    if (topicList.isSuccess && topicList.data !== null) {
      let topicContent = topicList.data.success.data.topics;
      setTopicData(topicContent)
      dispatch(resetHomepageData());
    } else if (topicList.isError) {
      dispatch(resetHomepageData());
    }
  }, [topicList])

  useEffect(() => {
    getData('homepageData').then((res) => {
      if (res !== undefined) {
        let topicContent = res.topics
        setTopicData(topicContent)
      } else {
        dispatch(fetchHomepageData());
      }
    }).catch((error) => console.log(error))
  }, [])

  useEffect(() => {
    if (questionDataFetch.isSuccess && questionDataFetch.data !== null) {
      setQuestionsData(questionDataFetch.data.success.data.questions);
      setActionPlan(questionDataFetch.data.success.data.actionStepQuestionEnabled);
      setPostCode(questionDataFetch.data.success.data.postcodeQuestionEnabled);
      dispatch(resetQuestionData());
    } else if (questionDataFetch.isError) {
      dispatch(resetQuestionData());
    }

  }, [questionDataFetch])




  const noticeCardDescription = (desciption, asking) => {
    setNoticeDescription(desciption);
    setQuestionInfoText(asking);
  }

  useEffect(() => {
  }, [questionsData])

  return (
    <div className='d-flex flex-grow-1'>
      {ACCESSIBILITY_FEATURE_ENABLED ?
        <FontResizeWidget minSize={14} maxSize={32} step={2} defaultSize={16} /> : null}
      <Helmet>
        <title>Questions | Get advice | My Housing Gateway</title>
        <meta property="og:title" content="Questions | Get advice | My Housing Gateway" />
        <meta name="twitter:card" content="Questions | Get advice | My Housing Gateway" />
        <meta description='If you have an issue with your rented property we can help by creating an action plan for you. This will explain the steps you should take in order to resolve your issue.' />
      </Helmet>
      {questionDataFetch.isFetching ? (
        <Loader message={"Loading....."} />
      ) : questionDataFetch.isSuccess && questionsData.length > 0 ? (
        <div className='start-questions'>
          <div className='container '>
            <div className='col-12 col-md-8 mb-0 breadcrumb-container d-none d-md-block'>
              <Breadcrumb />
            </div>

            {questionsData ? (
              <>
                <div className='d-flex start justify-content-between flex-column flex-md-row'>
                  <div className='col-12 col-md-8'>

                    <QuestionForm noticeDescription={noticeCardDescription}
                      question={questionsData} actionPlanQuestion={actionPlan}
                      postCode={postCode} formResponseData={location.state?.actionData || null}
                      questionID={location.state?.questionId || null}
                      onQuestionIndexChange={setCurrentQuestionIndex} />
                    {currentQuestionIndex === 1 ? (
                      <div className='errormobileclass'>
                         <ErrorMessage
                          // message="Please note this is not legal advice and if you are concerned about Section 21 or repurcussions of raising a complaint please seek additional advice before actioning the plan."
                          message="Please note this is not legal advice and if you are concerned about an eviction notice please seek additional advice before actioning the plan."
                          link="https://advicelocal.uk/find-an-adviser"
                        />
                        {/* <QuestionryErrorMessage
                          message="Please note this is not legal advice and if you are concerned about Section 21, please seek additional advice before actioning the plan."
                          message2="The law for renters is changing."
                          message3="On 1 May 2026, the Renters’ Rights Act will come into effect."
                          message4="In the meantime, your rights stay the same."
                          link="https://advicelocal.uk/find-an-adviser"
                          link_2="/news/renters-rights-act-when-are-my-housing-rights-changing"
                        /> */}
                      </div>
                    ) : null}
                       {currentQuestionIndex === 1 ? (
                      <div className='errormobileclass'>
                     
                        {/* <QuestionryErrorMessage
                          message2="The law for renters is changing."
                          message3="On 1 May 2026, the Renters’ Rights Act will come into effect."
                          message4="In the meantime, your rights stay the same."
                          link="https://advicelocal.uk/find-an-adviser"
                          link_2="/news/renters-rights-act-when-are-my-housing-rights-changing"
                        /> */}
                        <QuestionryErrorMessage
                          message2="The law for private renters has recently changed. From 1 May 2026, the Renters' Rights Act gives"
                          message3="renters greater legal protections. For example, your landlord must have a valid reason to evict you, and cannot evict you simply for making a complaint."
                          message4=""
                          link="https://advicelocal.uk/find-an-adviser"
                          link_2="/topics/renters-rights-act/private-renting-8"
                        />
                      </div>
                    ) : null}
                  </div>
                  <div className="col-12 col-md-3">
                    <div className="notice-card combined-card">
                      {questionInfoText && (
                        <div className="info-section why-asking">
                          <h2>Why are we asking this?</h2>
                          <p>{questionInfoText}</p>
                        </div>
                      )}
                      <div className="border-div"></div>
                      {noticeDescription && (
                        <div className="info-section did-you-know">
                          <h2>Did you know?</h2>
                          <p dangerouslySetInnerHTML={{ __html: noticeDescription }} />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </>
            ) : null}
            <div className='container start-topics subcontainer '>
              {topicList.isFetching ? (
                <Loader message={"Loading....."} />
              ) : topicsData.length > 0 ? (
                <>
                  <div className='card-container '>
                    <div className='divider'></div>
                    <p className='mb-0 text-18 fw-normal'>For general information, browse by topic instead</p>
                    <ul className='d-flex justify-content-start'>
                      {topicsData.map((item) => {
                        return <Cards type="topic" title={item.topicTitle} link={item.topicSlug} />
                      })}
                    </ul>
                    {/* <GetHelpSection description={"For general information, browse by topic instead"} /> */}
                  </div>
                </>
              ) : null}

            </div>
          </div>

        </div>
      ) : questionsData.length === 0 && questionDataFetch.isSuccess ?
        <div className='container'>
          <p className='text-24 mt-4'>No questions found</p>
        </div>
        : null}
    </div>
  )
}

export default QuestionsSet
